import * as React from 'react';

import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';

import { LogoLoaderPage } from '@commonTuna/react/components/UI/LogoLoader/LogoLoader';
import { Specialty } from '@commonTuna/react/objects/Specialty';

import DoctorCard from '@app/components/UI/DoctorCard/DoctorCardHome';
import { Doctor } from '@app/objects/Doctor';

import '@app/scss/pages/home.scss';

const SpecialtyInner: React.FC<{specialty: Specialty}> = ({ specialty }) => {
	return (<div className="container view-page">
		<div className="site-headline site-headline_with-button clearfix">
			<h1 className="pull-left">{specialty?.name}</h1>
		</div>
		{specialty?.doctors?.length > 0 && <div className="home" style={{ margin: 0, padding: 0 }}>
			<div className="home__container doctor-card-list" style={{ paddingLeft: 0, paddingRight: 0 }}>
				<div className="doctors-list">
					{specialty.doctors.map((item) =>
						<DoctorCard
							key={item.id}
							doctor={item.doctor as Doctor}
						/>)}
				</div>
				<br />
			</div>
		</div>}
		<div>
			{specialty?.text ? <div dangerouslySetInnerHTML={{ __html: `${specialty.text}` }} /> : '-'}
		</div>
	</div>);
};

const SpecialtyPage: React.FC = () => {
	return (
		<ServerPageProvider
			path="specialty"
			defaultTitle="Specialty"
			loader={<LogoLoaderPage />}
			inner={(page) => (
				<SpecialtyInner
					specialty={page?.item}
				/>
			)}
		/>
	);
};

export default SpecialtyPage;
